const RoleBadge = ({ text, bgColor, isOverLapping = false }) => {
  return (
    <span className={`badge badge-pill text-white text-capitalize ${isOverLapping && 'position-absolute'} role-pill`} style={{ backgroundColor: bgColor }}>{text}</span>
  )
}

export default RoleBadge;